let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cJsvM")).then(() => parcelRequire('bM58e'));